module.exports = __webpack_public_path__ + "img/215.problem_handle_door.4e17fdbd.svg";